import styles from '@/styles/components/common/CallToAction.module.scss'
import { Button } from '@/components/controls/Button'
import { PlanetDecor } from '@/components/decors/PlanetDecor'
import parse from 'html-react-parser'
import { useQuery } from '@/utils/url'

interface Props {
  title: string
}

export const CallToAction: React.FC<Props> = ({ title }) => {
  return (
    <div className={styles.cta}>
      <div className={styles.cta__container + ' container'}>
        <h3 className={styles.cta__title}>{parse(title)}</h3>
        <Button href={useQuery(process.env.NEXT_PUBLIC_CHECKOUT_URL as string)} type="primary">Join Our Waitlist</Button>
      </div>
      <PlanetDecor className="bottom-0 h-[320px] sm2:h-[500px] sm2:bottom-[-220px] xl:h-[1000px] xl:bottom-[-440px]"/>
    </div>
  )
}
